// Utilitaire pour gérer les erreurs d'API de façon centralisée
import { useNotification } from './Notification/NotificationContext';

export const createApiErrorHandler = (notifyError) => {
  return {
    handleFetchError: (error, customMessage = null) => {
      console.error("API Error:", error); // Garde pour le debug développeur
      
      if (customMessage) {
        notifyError(customMessage);
        return;
      }

      // Messages d'erreur par défaut basés sur le type d'erreur
      if (error.name === 'TypeError' && error.message.includes('fetch')) {
        notifyError('Erreur de connexion au serveur');
      } else if (error.message.includes('NetworkError')) {
        notifyError('Erreur réseau. Vérifiez votre connexion');
      } else if (error.message.includes('404')) {
        notifyError('Ressource non trouvée');
      } else if (error.message.includes('401')) {
        notifyError('Non autorisé. Veuillez vous reconnecter');
      } else if (error.message.includes('403')) {
        notifyError('Accès interdit');
      } else if (error.message.includes('500')) {
        notifyError('Erreur serveur interne');
      } else {
        notifyError('Une erreur inattendue s\'est produite');
      }
    },

    handleResponseError: async (response, customMessage = null) => {
      console.error("Response Error:", response.status, response.statusText);
      
      if (customMessage) {
        notifyError(customMessage);
        return;
      }

      // Messages d'erreur basés sur le code de statut
      switch (response.status) {
        case 400:
          notifyError('Données invalides');
          break;
        case 401:
          notifyError('Non autorisé. Veuillez vous reconnecter');
          break;
        case 403:
          notifyError('Accès interdit');
          break;
        case 404:
          notifyError('Ressource non trouvée');
          break;
        case 409:
          notifyError('Conflit de données');
          break;
        case 422:
          notifyError('Données non valides');
          break;
        case 500:
          notifyError('Erreur serveur interne');
          break;
        default:
          notifyError(`Erreur: ${response.status} ${response.statusText}`);
      }
    }
  };
};

// Hook personnalisé pour utiliser le gestionnaire d'erreurs
export const useApiErrorHandler = () => {
  const { notifyError } = useNotification();
  return createApiErrorHandler(notifyError);
}; 